import { Box, Button, Modal, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewPDF } from "../../../utils/viewPDF";
import ClearIcon from "@mui/icons-material/Clear";
import BasicTenderInfo from "../BriefTender/BasicTenderInfo";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ReviewBidsValue = () => {
  const { tenderId } = useParams();
  const [bidData, setBidData] = useState();
  const [tender, setTender] = useState();
  const [loading, setLoading] = useState(true);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [reason, setReason] = useState();
  const [bidId, setBidId] = useState();
  const navigate = useNavigate();
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openRebidModal, setOpenRebidModal] = useState(false);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [rebidData, setRebidData] = useState();
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [groupedData, setGroupedData] = useState();

  const handleClose = () => {
    setReason("");
    setRebidData();
    setOpenRejectModal(false);
    setOpenApproveModal(false);
    setOpenRebidModal(false);
  };

  const handleChange = (e) => {
    setRebidData({ ...rebidData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const getBidData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/bid/get-by-tender?tenderId=${tenderId}&username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      const allBids = res.data.filter(Boolean);
      setBidData(res.data);
      setGroupedData(groupBidsByVendor(allBids));
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const getTender = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setTender(res.data);
    } catch (error) {
      console.error("Error updating tender status:", error);
    }
  };
  useEffect(() => {
    getTender();
    getBidData();
  }, []);

  const validateForm = (formType = "") => {
    const newErrors = {};
    const data = rebidData || {};
    const now = new Date();

    const isEmpty = (value) => !value || value.trim?.() === "";

    const startDate = data.rebidStartDate
      ? new Date(data.rebidStartDate)
      : null;
    const endDate = data.rebidEndDate ? new Date(data.rebidEndDate) : null;

    if (formType === "reasonForm") {
      if (isEmpty(reason)) newErrors.reason = "Reason is required";
    }

    if (formType === "rebidForm") {
      if (!startDate) {
        newErrors.rebidStartDate = "Rebid Start Date & Time is required";
      } else {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (startDate < today) {
          newErrors.rebidStartDate =
            "Rebid Start Date & Time cannot be in the past";
        }
      }

      if (!endDate) {
        newErrors.rebidEndDate = "Rebid End Date & Time is required";
      } else if (endDate < now) {
        newErrors.rebidEndDate = "Rebid End Date & Time cannot be in the past";
      } else if (startDate && endDate <= startDate) {
        newErrors.rebidEndDate =
          "Rebid End Date & Time must be after Start Date & Time";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRejectBid = async () => {
    if (!validateForm("reasonForm")) return;
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/bid`,
        [
          {
            bidId: bidId,
            username: storedUser.username,
            status: "REJECTED",
            reason: reason,
          },
        ],
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOpenRejectModal(false);
      setBidId();
      getBidData();
      setLoading(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleApproveBid = async (status) => {
    try {
      const payload = bidData.map((bid) => ({
        bidId: bid.bidId,
        username: storedUser.username,
        status: status,
      }));
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/bid`, payload, {
        headers: { Authorization: `Bearer ${storedUser.accessToken}` },
      });
      navigate(`/dashboard/view-bid-data/${tenderId}`);
    } catch (error) {
      console.log(error);
    }
  };

  // const handleRebidBid = async (status) => {
  //   if (!validateForm("rebidForm")) return;
  //   setBtnLoading(true);
  //   try {
  //     const payload = bidData.map((bid) => ({
  //       bidId: bid.bidId,
  //       username: storedUser.username,
  //       status: status,
  //       rebidStartDate: rebidData.rebidStartDate,
  //       rebidEndDate: rebidData.rebidEndDate,
  //     }));
  //     await axios.put(`${process.env.REACT_APP_BACKEND_URL}/bid`, payload, {
  //       headers: { Authorization: `Bearer ${storedUser.accessToken}` },
  //     });
  //     navigate(`/dashboard/view-bid-data/${tenderId}`);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setBtnLoading(false);
  //   }
  // };
  const handleRebidBid = async (status) => {
    if (!validateForm("rebidForm")) return;
    setBtnLoading(true);
    try {
      const payload = bidData.map((bid) => ({
        tenderId,
        tenderId,
        username: storedUser.username,
        rebidStartDate: rebidData.rebidStartDate,
        rebidEndDate: rebidData.rebidEndDate,
      }));
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/bid/rebid`,
        payload,
        {
          headers: { Authorization: `Bearer ${storedUser.accessToken}` },
        }
      );
      navigate(`/dashboard/view-bid-data/${tenderId}`);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const groupBidsByVendor = (bids) => {
    const grouped = {};
    bids.forEach((bid) => {
      const name = bid.vendor.name;
      if (!grouped[name]) {
        grouped[name] = [];
      }
      grouped[name].push(bid);
    });
    return grouped;
  };

  const groupedWorkItems =
    tender &&
    tender.workItemDetails.reduce((acc, item) => {
      if (!acc[item.section]) acc[item.section] = [];
      acc[item.section].push(item);
      return acc;
    }, {});

  useEffect(() => {
    const leftRows = document.querySelectorAll("#leftTable tbody tr");
    const rightRows = document.querySelectorAll("#rightTable tbody tr");

    for (let i = 0; i < Math.min(leftRows.length, rightRows.length); i++) {
      const leftHeight = leftRows[i].getBoundingClientRect().height;
      const rightHeight = rightRows[i].getBoundingClientRect().height;

      const maxHeight = Math.max(leftHeight, rightHeight);

      leftRows[i].style.height = `${maxHeight}px`;
      rightRows[i].style.height = `${maxHeight}px`;
    }
  }, [tender, groupedWorkItems, groupedData]);

  return (
    <div style={{ postiton: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <Typography variant="h6">Basic Information</Typography>
      <BasicTenderInfo tender={tender} />
      <Typography variant="h6">Bids Received</Typography>
      <Box className="dashboard-container" p={10}>
        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            Loading...
          </Box>
        ) : tender && bidData && bidData.filter(Boolean).length > 0 ? (
          <Box sx={{ display: "flex", overflow: "hidden" }}>
            {/* Fixed Left Table */}
            <table
              id="leftTable"
              style={{
                borderCollapse: "collapse",
                width: "500px",
                tableLayout: "fixed",
                textAlign: "center",
                border: "1px solid #ccc",
                marginBottom: "58px",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{ padding: "9px", width: "150px", height: "61px" }}
                  >
                    Item Name
                  </th>
                  <th style={{ padding: "9px", width: "240px" }}>
                    Item Description
                  </th>
                  <th style={{ padding: "9px", width: "100px" }}>UOM</th>
                  <th style={{ padding: "9px", width: "100px" }}>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(groupedWorkItems).map(
                  ([section, items], sectionIndex) => (
                    <React.Fragment key={sectionIndex}>
                      <tr
                        style={{
                          borderTop: "1px solid #ccc",
                          fontWeight: "bold",
                        }}
                      >
                        <td
                          colSpan={4}
                          style={{
                            textAlign: "left",
                            padding: "0px 10px",
                            height: "41px",
                          }}
                        >
                          Section: {section}
                        </td>
                      </tr>
                      {items
                        .sort((a, b) => a.itemOrder - b.itemOrder)
                        .map((item, i) => (
                          <tr key={i}>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                                // height: "50px",
                                padding: "10px",
                              }}
                            >
                              {item.itemName}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.description}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.unit}
                            </td>
                            <td
                              style={{
                                borderTop: "1px solid #ccc",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {item.quantity}
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  )
                )}
                <tr>
                  <td
                    colSpan={4}
                    style={{
                      borderTop: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Grand Total (in &#8377;):
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Scrollable Vendor Table */}
            <Box sx={{ overflowX: "scroll" }}>
              <table
                id="rightTable"
                style={{
                  borderCollapse: "collapse",
                  minWidth: `${bidData && bidData?.length * 200}px`,
                  textAlign: "center",
                  border: "1px solid #ccc",
                  borderLeft: "none",
                }}
              >
                <thead>
                  <tr>
                    {bidData?.filter(Boolean).map((bid, index) => (
                      <th
                        key={index}
                        colSpan={2}
                        style={{
                          width: "300px",
                          padding: "9px",
                          borderBottom: "1px solid #ccc",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        {bid.vendor.name}
                      </th>
                    ))}
                  </tr>
                  <tr>
                    {bidData.filter(Boolean).map((_, index) => (
                      <React.Fragment key={index}>
                        <th
                          key={`rate-${index}`}
                          style={{
                            width: "100px",
                            borderTop: "1px solid #ccc",
                            borderRight: "1px solid #ccc",
                          }}
                        >
                          Rate (in &#8377;)
                        </th>
                        <th
                          key={`total-${index}`}
                          style={{
                            width: "100px",
                            borderTop: "1px solid #ccc",
                            borderRight: "1px solid #ccc",
                          }}
                        >
                          Total (in &#8377;)
                        </th>
                      </React.Fragment>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(groupedWorkItems).map(
                    ([section, items], sectionIndex) => (
                      <React.Fragment key={sectionIndex}>
                        {/* Section Totals */}
                        <tr
                          style={{
                            borderTop: "1px solid #ccc",
                            fontWeight: "bold",
                          }}
                        >
                          {Object.entries(groupedData).flatMap(
                            ([vendor, bids]) =>
                              bids.map((bid, i) => {
                                const sectionItems = bid.bidWorkItems.filter(
                                  (bi) =>
                                    items.find(
                                      (wi) => wi.itemName === bi.itemName
                                    )
                                );
                                const sectionTotal = sectionItems.reduce(
                                  (sum, si) => sum + ((si.quantity * si.rate) || 0),
                                  0
                                );
                                return (
                                  <React.Fragment
                                    key={`${vendor}-sectionTotal-${i}-${sectionIndex}`}
                                  >
                                    <td
                                      colSpan={2}
                                      style={{
                                        textAlign: "end",
                                        padding: "10px",
                                        height: "41px",
                                        borderRight: "1px solid #ccc",
                                      }}
                                    >
                                      {new Intl.NumberFormat("en-IN", {
                                        style: "decimal",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }).format(sectionTotal)}
                                    </td>
                                  </React.Fragment>
                                );
                              })
                          )}
                        </tr>
                        {items.map((item, rowIndex) => (
                          <tr key={rowIndex}>
                            {Object.entries(groupedData).flatMap(
                              ([vendor, bids]) =>
                                bids.map((bid, i) => {
                                  const matchedItem = bid.bidWorkItems.find(
                                    (bi) =>
                                      bi.itemName === item.itemName &&
                                      bi.description === item.description &&
                                      bi.quantity === item.quantity &&
                                      bi.unit === item.unit
                                  );
                                  return (
                                    <React.Fragment
                                      key={`${vendor}-item-${i}-${rowIndex}`}
                                    >
                                      <td
                                        style={{
                                          borderTop: "1px solid #ccc",
                                          borderRight: "1px solid #ccc",
                                          // height: "50px",
                                          padding: "10px",
                                        }}
                                      >
                                        {matchedItem?.rate || ""}
                                      </td>
                                      <td
                                        style={{
                                          borderTop: "1px solid #ccc",
                                          borderRight: "1px solid #ccc",
                                        }}
                                      >
                                        {(matchedItem?.quantity * matchedItem?.rate).toFixed(2) || ""}
                                      </td>
                                    </React.Fragment>
                                  );
                                })
                            )}
                          </tr>
                        ))}
                      </React.Fragment>
                    )
                  )}
                  <tr
                    style={{ fontWeight: "bold", borderTop: "1px solid #ccc" }}
                  >
                    {Object.entries(groupedData).flatMap(([vendor, bids]) =>
                      bids.map((bid, i) => {
                        const grandTotal = bid.bidWorkItems.reduce(
                          (acc, item) => acc + ((item.quantity * item.rate) || 0),
                          0
                        );
                        return (
                          <td
                            key={`${vendor}-grand-${i}`}
                            colSpan={2}
                            style={{
                              textAlign: "end",
                              padding: "10px",
                              borderRight: "1px solid #ccc",
                            }}
                          >
                            {new Intl.NumberFormat("en-IN", {
                              style: "decimal",
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }).format(grandTotal)}
                          </td>
                        );
                      })
                    )}
                  </tr>
                </tbody>
              </table>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  minWidth: `${bidData && bidData?.length * 200}px`,
                }}
              >
                {bidData.filter(Boolean).map((bid, i) => (
                  <Box
                    key={i}
                    sx={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <Button
                      className="btn-outlined btn-reject"
                      sx={{
                        margin: "10px auto !important",
                        padding: "0 !important",
                        width: "100px !important",
                        fontSize: "12px",
                      }}
                      onClick={() => {
                        setOpenRejectModal(true);
                        setBidId(bid.bidId);
                      }}
                    >
                      Reject
                    </Button>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        ) : (
          <Typography variant="h6" textAlign="center" mt={5}>
            No vendor bid for the tender
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Box sx={{ display: "flex", gap: 5 }}>
          <Button
            className="btn-outlined"
            onClick={() => navigate(`/dashboard/view-bid-data/${tenderId}`)}
          >
            Back
          </Button>
          <Button
            className="btn-outlined"
            onClick={() => setOpenRebidModal(true)}
          >
            Request Rebid
          </Button>
          <Button
            className="btn-contained"
            onClick={() => setOpenApproveModal(true)}
          >
            Approve
          </Button>
        </Box>
      </Box>

      <Modal
        open={openRejectModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            textAlign={"start"}
          >
            Bid Reject
          </Typography>
          <label htmlFor="reason">
            Please give feedback why reject the bid*
          </label>
          <textarea
            className={`${errors.reason && "input-error"}`}
            name="reason"
            id="reason"
            onChange={(e) => {
              setReason(e.target.value);
              setErrors({ ...errors, reason: "" });
            }}
            rows={8}
          ></textarea>
          {errors.reason && <p className="error">{errors.reason}</p>}
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button className="btn-outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              className="btn-outlined btn-reject"
              onClick={handleRejectBid}
            >
              Reject
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openApproveModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <span
              style={{
                background: "#E5E5E5",
                borderRadius: "50%",
                padding: "4px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={handleClose}
            >
              <ClearIcon />
            </span>
          </div>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {bidData?.some(
              (bid) => bid?.awardee2?.userRoleName === storedUser.userRole[0]
            )
              ? "The bid in the shortlist will be awarded to the vendor"
              : "All the remaining bids in the shortlist will be sent further"}
          </Typography>
          <Box
            className="btn-container"
            sx={{
              width: "100%",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {storedUser.userRole[0] === "PURCHASE_HEAD" && (
              <Button
                className="btn-contained"
                onClick={() => handleApproveBid("SHORTLISTED")}
              >
                Okay
              </Button>
            )}
            {bidData?.some(
              (bid) =>
                bid?.awardee1 != null &&
                bid?.awardee1?.userRoleName === storedUser.userRole[0]
            ) && (
              <Button
                className="btn-contained"
                onClick={() => handleApproveBid("APPROVED")}
              >
                Okay
              </Button>
            )}
            {bidData?.some(
              (bid) => bid?.awardee2?.userRoleName === storedUser.userRole[0]
            ) && (
              <Button
                className="btn-contained"
                onClick={() => handleApproveBid("AWARDED")}
              >
                Okay
              </Button>
            )}
          </Box>
        </Box>
      </Modal>

      {/* Rebid Modal */}
      <Modal
        open={openRebidModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            textAlign={"start"}
          >
            Please Enter Valid Details for Rebid
          </Typography>
          <label htmlFor="rebidStartDate">Rebid Submission Start Date</label>
          <input
            type="datetime-local"
            name="rebidStartDate"
            id="rebidStartDate"
            onChange={handleChange}
            className={`${errors.rebidStartDate && "input-error"}`}
          />
          {errors.rebidStartDate && (
            <p className="error">{errors.rebidStartDate}</p>
          )}
          <label htmlFor="rebidEndDate">Rebid Submission End Date</label>
          <input
            type="datetime-local"
            name="rebidEndDate"
            id="rebidEndDate"
            onChange={handleChange}
            className={`${errors.rebidEndDate && "input-error"}`}
          />
          {errors.rebidEndDate && (
            <p className="error">{errors.rebidEndDate}</p>
          )}
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button className="btn-outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              className="btn-contained"
              onClick={() => handleRebidBid("REBID")}
              disabled={btnLoading}
            >
              {btnLoading ? "Submitting" : "Send For Rebid"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default ReviewBidsValue;
